import { DraftRecognitionEmbeds, listDraftRecognitions } from '@kudos/http-client'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ALL_RECOGNITION_QK } from './recognitionQueryKeys'

// The draft endpoint only supports these embeds; reactions/comments/endorsements
// cannot exist on a draft.
export const draftRecognitionEmbeds: DraftRecognitionEmbeds[] = [
  'sendToAndSender',
  'attachmentUrls',
  'qualities',
]

type PaginatedDraftRecognitionsOptions = {
  enabled?: boolean
}

const PAGE_SIZE = 20

const usePaginatedDraftRecognitions = ({
  enabled = true,
}: PaginatedDraftRecognitionsOptions = {}) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isRefetching, refetch } =
    useInfiniteQuery({
      queryKey: [ALL_RECOGNITION_QK, 'drafts'],
      queryFn: ({ pageParam = 1 }) =>
        listDraftRecognitions({
          page: pageParam,
          pageSize: PAGE_SIZE,
          sorting: ['-createdAt'],
          embeds: draftRecognitionEmbeds,
        }),
      initialPageParam: 1,
      getNextPageParam: lastPage => lastPage.next,
      enabled,
    })

  const recognitionsData = useMemo(() => {
    return data?.pages.flatMap(page => page.results) || []
  }, [data])

  return {
    fetchMoreRecognitions: fetchNextPage,
    hasMoreRecognitions: hasNextPage,
    isFetchingNextPage,
    isLoading,
    isRefetching,
    recognitionsData,
    refetch,
  }
}

export default usePaginatedDraftRecognitions
